module.exports = __webpack_public_path__ + "img/kerry-logo.cbf833c9.jpg";